<template>

  <!-- slide -->
  <div v-if="audioType === 'slide'" id="slide">

    <div class="slide" :style="'height:calc(100vw - 30px); max-height:450px'">
      <transition name="slide-fade" mode="in-out">
        <div class="slide-image square" :style="{backgroundImage: 'url(' + audioList[playIndex].image + ')'}" :key="playIndex"></div>
      </transition>
    </div>

    <div id="contents">
      <div id="controller" class="buttons-audio">
        
        <!-- playAudio() or pauseAudio() -->
        <a @click="playingAudio()" class="button button-secondary flex-center play-audio">
          <i class="material-icons">{{ playing ? 'pause' : 'play_arrow' }}</i>
        </a>

        <a @click="replayAudio()" class="button button-secondary flex-center replay-audio"><i class="material-icons">replay</i></a>

      </div>

      <!-- audio tag is inserted from audio.js -->
    </div>
  </div>
  <!-- /slide -->

  <!-- audio -->
  <div v-else id="audio">
    <div id="contents">
      <div id="controller" class="buttons-audio">

        <!-- playAudio() or pauseAudio() -->
        <a @click="playingAudio()" class="button button-secondary flex-center">
          <i class="material-icons">{{ playing ? 'pause' : 'play_arrow' }}</i>
        </a>

        <a @click="replayAudio()" class="button button-secondary flex-center"><i class="material-icons">replay</i></a>

        <!-- <div id="seekbar"></div>
        <div id="time">
          <span id="current">{{ currentTime }}</span>
          <span id="duration">{{ durationTime }}</span>
        </div> -->

        <!-- <i class="material-icons">settings</i>
        <select v-model="selectedSpeed" @change="rateAudio(selectedSpeed)">
          <option disabled value="">速度</option>
          <option v-for="speed in optionSpeed" 
            :value="speed.val" 
            :key="speed.val">
          {{ speed.name }}
          </option>
        </select> -->
      </div>

      <!-- audio tag is inserted from audio.js -->
    </div>
  </div>
  <!-- /audio -->

</template>

<script>
import {mapGetters} from 'vuex';
import {audioListPlayer} from '../../helpers/audio';

export default {
  name: "LessonMultiAudio",
  props: {
    audioList: {
      type: Array,
      required: true
    },
    audioType: {
      type: String,
      required: true
    },
  },
  data(){
    return{
      // selectedSpeed: 1,
      // optionSpeed: [
      //   { id: 1, val: 0.5, name: '0.5x' }, 
      //   { id: 2, val: 0.75, name: '0.75x' }, 
      //   { id: 3, val: 1, name: 'Normal' }, 
      //   { id: 4, val: 1.25, name: '1.25x' }, 
      //   { id: 5, val: 1.5, name: '1.5x' },
      //   { id: 5, val: 4, name: '4x' },
      // ],
      audio: undefined,
      audioListPlayer: undefined,
      playList: [],
      stopAutoSkip: false,
      playIndex: 0,
      playing: false,

      current: 0,
      totalSec: 0,
    }
  },
  computed: {
    ...mapGetters([
      'selectedLanguage'
    ]),
    currentTime() {
      return this.audioListPlayer.formatTime(this.current)
    },
    durationTime() {
      return this.audioListPlayer.formatTime(this.totalSec)
    }
  },
  
  created() {
  },

  mounted() {
    
    let ref = this
    ref.audioListPlayer = new audioListPlayer();

    // create audio playlist
    Array.prototype.forEach.call(Object(ref.audioList), (row, idx) => {
      ref.playList.push({ file : row.audio, stopautoskip: ref.stopAutoSkip, plyr: null });
    })
    ref.audioListPlayer.setPlaylist(ref.playList);

    ref.audio = document.querySelectorAll('audio')[ref.playIndex];
    // ref.audio.addEventListener('timeupdate', (event) => {
    //   ref.current = ref.audioListPlayer.getCurrentTime();
    // });

    ref.audioListPlayer.setCallback(function(type) {
      if(type == 'end') {
        console.log('end')
        ref.playIndex = 0
        ref.playing = false
      } else if(type == 'skip') {
        console.log('skip')
        // ref.totalSec += ref.audioListPlayer.getDuration();
        ref.playIndex = ref.playIndex + 1;
      }
      ref.$emit('playevent', { type: type, index: ref.playIndex })
    });
  },
  
  beforeDestroy() {
    console.log('LessonMultiAudio beforeDestroy:');
    if (this.audioListPlayer) {
      this.audioListPlayer.destroy(); // 前に audio.js に追加した destroy メソッドを呼び出す
    }
  },
  
  watch: {
    playing() {
      if (this.playing) {
        this.playAudio()
      } else {
        this.pauseAudio()
      }
    },
    // playIndex:{
    //   handler (newPlayIndex, oldPlayIndex) {
    //     // this.current += this.duration
    //     this.audio = document.querySelectorAll('audio')[newPlayIndex]
    //     this.audio.addEventListener('timeupdate', (event) => {
    //       this.current = this.audioListPlayer.getCurrentTime() + this.totalSec;
    //     });
    //     // this.duration = this.audioListPlayer.getDuration();
    //   }
    // }
  },
  methods: {
    playingAudio() {
      this.playing = !this.playing
    },
    rateAudio(speed) {
      console.log('rateAudio')
      console.log(speed)
      this.audioListPlayer.rate(speed);
    },
    replayAudio() {
      console.log('replayAudio')
      this.playIndex = 0;
      this.playing = true
      this.audioListPlayer.skipTo(this.playIndex);
    },
    playAudio() {
      console.log('playAudio')
      this.playing = true
      this.audioListPlayer.play();
    },
    pauseAudio() {
      console.log('pauseAudio')
      this.playing = false
      this.audioListPlayer.pause();
    },
    stopAudio() {
      console.log('stopAudio')
      this.playing = false
      this.audioListPlayer.stop();
    },
  }
}
</script>


<style scoped lang="scss">
  .slide {
    position: relative;
    overflow: hidden;
  }
  @media screen and (max-width: 450px) {
    .slide-image.square {
      height: 0;
      padding-bottom: 100%;
    }
  }
  .slide-image {
    width: 100%;
    height: 100%;
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: opacity .3s;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    opacity: 0;
  }
</style>
